import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { environment } from '@environment';

@JsonApiModelConfig({
  baseUrl: `${environment.identityManagerBaseUrl}/api/v1`,
  type: 'users',
})
export class User extends JsonApiModel {
  @Attribute()
  email!: string;

  @Attribute({ serializedName: 'company_id' })
  companyId!: string;

  @Attribute({ serializedName: 'last_sign_in_at' })
  lastSignInAt!: Date;

  @Attribute()
  subdomain!: string;
}
